'use strict';
var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};



//////////////////
// WEBPACK FOOTER
// ./~/is-plain-obj/index.js
// module id = 394
// module chunks = 230186691558513